import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Instruction from "../instructions/Instruction";
import Documents from "../Documents/documents";
import axios from "axios";
import AuthUser from "../Loji/loji"; 

const Preview = ({ formData, prevStep, nextStep }) => {
  const {
    firstName,
    lastName,
    cnicStudent,
    cnicFather,
    mobileStudent,
    district,
    gender,
    contactNumber,
    email,
    photo,
    academic,
    family,
    finance,
    property,
    siblings,
  } = formData;

  const [photoURL, setPhotoURL] = useState(null);
  const { http } = AuthUser();
  const SEEF_FORM = "form-submit2850";
  const [loading, setLoading] = useState(false);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "Affidavit.pdf";
    link.download = "Sample-Affidavit-PDF";
    link.target = "_blank";
    link.rel = "noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    if (formData && formData?.photo) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPhotoURL(reader.result);
      };
      reader.readAsDataURL(formData?.photo);
    }
  }, [formData]);

  if (!formData) {
    return <div>Loading...</div>;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); 

    const dataToSend = {
      finance: formData.finance,
      familyMembers: formData.family?.familyMembers,
      siblingsscholarship: formData.siblings?.siblingsScholarship,
      academic: formData.academic,
      property: formData.property,
      firstName,
      lastName,
      cnicStudent,
      cnicFather,
      mobileStudent,
      district,
      gender,
      contactNumber,
      email,
      photo,
    };
  
    try {
      const response = await http.post(SEEF_FORM, dataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  
      window.alert(response.data.message); 
      nextStep();
    } catch (error) {
      console.error("Form submission error:", error);
  
      if (error.response) {
        const errorMessage = error.response.data.message || "Something went wrong!";
        window.alert(errorMessage);
      } else if (error.request) {
        window.alert("No response received from server!");
      } else {
        window.alert("Error while submitting form!");
      }
    } finally {
      setLoading(false); 
    }
  };
  
  const fatherGuardian = formData.family?.familyMembers?.find(
    (member) =>
      member?.relationship === "Father" || member?.relationship === "Guardian"
  );

  return (
    <div className="">
      <div className="shadow-2xl bg-gray-100 p-6 text-center mx-auto">
        <div className="p-2 mt-6 text-2xl rounded-lg font-bold bg-red-500 -mb-6 text-white">
          Read the Form Carefully before clicking on SUBMIT button, because once
          the form is submitted it cannot be Edited or Corrected.
        </div>
        <Instruction />

        {/* Right Content - Photo */}
        <div className="flex justify-end mb-4">
          <div className="w-24 h-32 border-2 border-gray-700 bg-white flex items-center justify-center overflow-hidden">
            {photoURL ? (
              <img
                src={photoURL}
                alt="Student Photo"
                className="w-full h-full object-cover"
              />
            ) : (
              <span className="text-xs text-gray-400">No Photo</span>
            )}
          </div>
        </div>

        {/* Academic Information */}
        <div className="text-left mx-3 sm:mx-6">
          <h1 className="font-bold text-2xl">1. ACADEMIC INFORMATION</h1>
          <hr className="border-t-2 border-gray-700 my-5 rounded-none" />

          <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
            <div className="mb-4 md:w-1/2">
              <label className="block font-bold mb-2">
                Apply as <span className="text-red-700 font-semibold">*</span>:{" "}
                {academic?.applyAs}
              </label>
            </div>
            <div className="mb-4 md:w-1/2">
              <label className="block font-bold mb-2">
                University Reg. No #{" "}
                <span className="text-red-700 font-semibold">*</span>:{" "}
                {academic?.registrationNumber}
              </label>
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
            <div className="mb-4 md:w-1/2">
              <label className="block font-bold mb-2">
                Year of Registration{" "}
                <span className="text-red-700 font-semibold">*</span>:{" "}
                {academic?.registrationYear}
              </label>
            </div>
            <div className="mb-4 md:w-1/2">
              <label className="block font-bold mb-2">
                Year of Admission{" "}
                <span className="text-red-700 font-semibold">*</span>:{" "}
                {academic?.yearOfAdmission}
              </label>
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
            <div className="mb-4 md:w-1/2">
              <label className="block font-bold mb-2">
                Name of University / Institute{" "}
                <span className="text-red-700 font-semibold">*</span>:{" "}
                {academic?.universityName}
              </label>
            </div>
            <div className="mb-4 md:w-1/2">
              <label className="block font-bold mb-2">
                Discipline <span className="text-red-700 font-semibold">*</span>:{" "}
                {academic?.discipline}
              </label>
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
            <div className="mb-4 md:w-1/2">
              <label className="block font-bold mb-2">
                {academic?.gradeSystem === "GPA"
                  ? "GPA"
                  : academic?.gradeSystem === "Percentage"
                  ? "Percentage"
                  : "Grade System"}
                <span className="text-red-700 font-semibold">*</span>:{" "}
                {academic?.gradeSystem === "GPA"
                  ? academic?.gpa
                  : academic?.gradeSystem === "Percentage"
                  ? academic?.percentage
                  : "First Year Student"}
              </label>
            </div>
          </div>
        </div>

        {/* Personal Information */}
        <div className="text-left mx-3 sm:mx-6">
          <hr className="border-t-2 border-gray-700 my-5 rounded-none" />
          <h1 className="font-bold text-2xl text-left">
            2. PERSONAL INFORMATION
          </h1>
          <hr className="border-t-2 border-gray-700 my-5 rounded-none" />

          <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
            <div className="mb-4 md:w-1/2">
              <label className="block font-bold mb-2">
                Full Name <span className="text-red-700 font-semibold">*</span>:{" "}
                {firstName} {lastName}
              </label>
            </div>
             <div className="mb-4 md:w-1/2">
              <label className="block font-bold mb-2">
                CNIC No. <span className="text-red-700 font-semibold">*</span>:{" "}
                {cnicStudent}
              </label>
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
            <div className="mb-4 md:w-1/2">
              <label className="block font-bold mb-2">
                Gender <span className="text-red-700 font-semibold">*</span>:{" "}
                {gender}
              </label>
            </div>
            <div className="mb-4 md:w-1/2">
              <label className="block font-bold mb-2">
                Domicile <span className="text-red-700 font-semibold">*</span>:{" "}
                {district}
              </label>
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
            <div className="mb-4 md:w-1/2">
              <label className="block font-bold mb-2">
                Father/Guardian Name <span className="text-red-700 font-semibold">*</span>:{" "}
                {fatherGuardian ? fatherGuardian.name : ""}
              </label>
            </div>
             <div className="mb-4 md:w-1/2">
              <label className="block font-bold mb-2">
                Father CNIC No. <span className="text-red-700 font-semibold">*</span>:{" "}
                {cnicFather}
              </label>
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
            <div className="mb-4 md:w-1/2">
              <label className="block font-bold mb-2">
                Phone Number <span className="text-red-700 font-semibold">*</span>:{" "}
                {contactNumber}
              </label>
            </div>
            <div className="mb-4 md:w-1/2">
              <label className="block font-bold mb-2">
                Phone Residence <span className="text-red-700 font-semibold">*</span>:{" "}
                {mobileStudent}
              </label>
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
            <div className="mb-4 md:w-1/2">
              <label className="block font-bold mb-2">
                Email <span className="text-red-700 font-semibold">*</span>:{" "}
                {email}
              </label>
            </div>
          </div>
        </div>

        {/* Family Members */}
        <div className="mx-3 sm:mx-6 text-left">
          <hr className="border-t-2 border-gray-700 my-5 rounded-none" />
          <h1 className="font-bold text-2xl">Details of Family Members</h1>
          <hr className="border-t-2 border-gray-700 my-5 rounded-none" />

          {(!family?.familyMembers || family.familyMembers.length === 0) ? (
            <p>No Family member added yet.</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border text-center">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border px-4 py-2 whitespace-nowrap">Name</th>
                    <th className="border px-4 py-2 whitespace-nowrap">Age</th>
                    <th className="border px-4 py-2 whitespace-nowrap">Relationship</th>
                    <th className="border px-4 py-2 whitespace-nowrap">Marital status</th>
                    <th className="border px-4 py-2 whitespace-nowrap">Occupation</th>
                    <th className="border px-4 py-2 whitespace-nowrap">Organisation</th>
                  </tr>
                </thead>
                <tbody>
                  {family.familyMembers.map((member, index) => (
                    <tr
                      key={index}
                      className={index % 2 === 0 ? "bg-gray-100" : "bg-white"}
                    >
                      <td className="border px-4 py-2">{member.name}</td>
                      <td className="border px-4 py-2">{member.age} Years</td>
                      <td className="border px-4 py-2">{member.relationship}</td>
                      <td className="border px-4 py-2">{member.maritalStatus}</td>
                      <td className="border px-4 py-2">{member.occupation}</td>
                      <td className="border px-4 py-2">{member.organization}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Finance Section */}
        <div className="mx-3 sm:mx-6 text-left">
          <hr className="border-t-2 border-gray-700 my-5 rounded-none" />
          <h1 className="font-bold text-2xl">3. FINANCE INFORMATION</h1>
          <hr className="border-t-2 border-gray-700 my-5 rounded-none" />
          <div className="font-bold underline text-lg py-3">
            RESIDENTIAL PROPERTY / IMMOVABLE ASSETS DETAILS
          </div>
        </div>

        <div className="my-4 mx-3 sm:mx-6 overflow-x-auto">
          <table className="table-auto w-full text-center border">
            <thead className="bg-gray-200">
              <tr>
                <th className="px-4 py-2 border">Property Type</th>
                <th className="px-4 py-2 border">Exact Location</th>
                <th className="px-4 py-2 border">Area (in Acres/Sq Yards)</th>
                <th className="px-4 py-2 border">Value (PKR)</th>
              </tr>
            </thead>
            <tbody>
              <tr className="bg-white">
                <td className="border px-4 py-2">{property?.propertyType}</td>
                <td className="border px-4 py-2">{property?.propertyAddress}</td>
                <td className="border px-4 py-2">{property?.propertyArea} {property?.propertyUnit}</td>
                <td className="border px-4 py-2">{property?.propertyValue}</td>
              </tr>
              <tr className="bg-gray-100">
                <td className="border px-4 py-2">{property?.assetType}</td>
                <td className="border px-4 py-2">{property?.assetAddress}</td>
                <td className="border px-4 py-2">{property?.assetArea} {property?.assetUnit}</td>
                <td className="border px-4 py-2">{property?.assetValue}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Source of Income */}
        <div className="mx-3 sm:mx-6 text-left font-bold underline text-lg py-3">
          SOURCE OF INCOME PER ANNUM (Provide DOCUMENTARY EVIDENCE FOR INCOME)
        </div>
        <div className="my-4 mx-3 sm:mx-6 overflow-x-auto">
          <table className="table-auto w-full text-center border mb-2">
            <thead className="bg-gray-200">
              <tr>
                <th className="px-4 py-2 border"></th>
                <th className="px-4 py-2 border">Father&apos;s</th>
                <th className="px-4 py-2 border">Mother&apos;s</th>
                <th className="px-4 py-2 border">Brother&apos;s</th>
                <th className="px-4 py-2 border">Sister&apos;s</th>
                <th className="px-4 py-2 border">Guardian&apos;s / Other&apos;s</th>
              </tr>
            </thead>
            <tbody>
              <tr className="bg-white">
                <td className="border px-4 py-2 font-bold bg-gray-50 text-left">Profession</td>
                <td className="border px-4 py-2">{finance?.fatherProfession}</td>
                <td className="border px-4 py-2">{finance?.motherProfession}</td>
                <td className="border px-4 py-2">{finance?.brotherProfession}</td>
                <td className="border px-4 py-2">{finance?.sisterProfession}</td>
                <td className="border px-4 py-2">{finance?.guardianProfession}</td>
              </tr>
              <tr className="bg-gray-100">
                <td className="border px-4 py-2 font-bold bg-gray-50 text-left">Salary/Pension</td>
                <td className="border px-4 py-2">{finance?.fatherSource}</td>
                <td className="border px-4 py-2">{finance?.motherSource}</td>
                <td className="border px-4 py-2">{finance?.brotherSource}</td>
                <td className="border px-4 py-2">{finance?.sisterSource}</td>
                <td className="border px-4 py-2">{finance?.guardianSource}</td>
              </tr>
              <tr className="bg-white">
                <td className="border px-4 py-2 font-bold bg-gray-50 text-left">Per Annum Income</td>
                <td className="border px-4 py-2">{finance?.fatherIncome}</td>
                <td className="border px-4 py-2">{finance?.motherIncome}</td>
                <td className="border px-4 py-2">{finance?.brotherIncome}</td>
                <td className="border px-4 py-2">{finance?.sisterIncome}</td>
                <td className="border px-4 py-2">{finance?.guardianIncome}</td>
              </tr>
            </tbody>
          </table>
          
          <table className="w-full border text-center">
            <tbody>
              <tr className="bg-gray-50">
                <td className="border w-1/4 px-4 py-2 text-xl font-bold text-left">
                  Total Income Per Annum
                </td>
                <td className="border px-4 py-2 w-3/4 bg-white font-semibold text-2xl text-left text-blue-700">
                  Rs. {finance?.totalIncome}/-
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Siblings Section */}
        <div className="flex flex-col sm:flex-row gap-x-3 items-start mx-3 sm:mx-6 mt-4">
          <p className="text-xl font-bold mb-2 underline text-left">
            Sibling(s) availing SEEF Scholarship?:{" "}
            <span className="text-blue-700">{siblings?.siblingsScholarship?.siblingsReceivingScholarship}</span>
          </p>
        </div>

        {siblings?.siblingsScholarship?.siblingsReceivingScholarship === "yes" && (
          <div className="mx-3 sm:mx-6 text-left">
            <p className="mt-2 mb-2 text-lg font-semibold">
              Details of Sibling Availing SEEF Scholarship:
            </p>

            <table className="border-collapse w-full border text-center">
              <thead className="bg-gray-200">
                <tr>
                  <th className="border py-2 px-4">Name</th>
                  <th className="border py-2 px-4">Relationship</th>
                  <th className="border py-2 px-4">University</th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-white">
                  <td className="border py-2 px-4">{siblings?.siblingsScholarship?.name}</td>
                  <td className="border py-2 px-4">{siblings?.siblingsScholarship?.relationship}</td>
                  <td className="border py-2 px-4">{siblings?.siblingsScholarship?.university}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        <div className="mx-3 sm:mx-6">
          <Documents />
        </div>

        {/* Sample Affidavit */}
        <div className="mx-3 sm:mx-6 text-left">
          <hr className="border-t-2 border-gray-700 my-5 rounded-none" />
          <h1 className="font-bold text-2xl">5. DOWNLOAD SAMPLE AFFIDAVIT</h1>
          <hr className="border-t-2 border-gray-700 my-5 rounded-none" />

          <div className="flex flex-col sm:flex-row text-red-600 gap-4 items-start sm:items-center font-bold py-3">
            <p className="flex-1">
              Before Submitting the Form Online, Download the Sample Affidavit Form.
            </p>
            <button
              type="button"
              onClick={handleDownload}
              className="px-6 py-2 bg-blue-600 text-white rounded-md whitespace-nowrap hover:bg-blue-700 transition"
            >
              Download SAMPLE AFFIDAVIT
            </button>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-between mx-3 sm:mx-6 mt-6">
          <button
            type="button"
            onClick={prevStep}
            className="px-6 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition"
          >
            Back
          </button>

          <button
            type="button"
            onClick={handleSubmit}
            className={`px-6 py-2 bg-blue-600 text-white rounded-md transition ${
              loading ? "opacity-50 cursor-not-allowed" : "hover:bg-blue-700"
            }`}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Preview;